import { styled } from "@mui/material";

const PREFIX = "PaperCandidateChallengeActions";

export const paperCandidateChallengeActionsClasses = {
  root: `${PREFIX}-root`,
  collapse: `${PREFIX}-collapse`,
  actionsContainer: `${PREFIX}-actionsContainer`,
  actionsGroupContainer: `${PREFIX}-actionsGroupContainer`,
  actionsGroupLabel: `${PREFIX}-actionsGroupLabel`,
};

export const PaperCandidateChallengeActionsRoot = styled("div")(({ theme }) => ({
  [`&.${paperCandidateChallengeActionsClasses.root}`]: {
    display: "flex",
    flexDirection: "column",
    alignSelf: "start",
  },
  [`& .${paperCandidateChallengeActionsClasses.collapse}`]: {
    alignItems: "center",
    flexDirection: "row",
    gap: theme.spacing(1),
    "&:hover": { cursor: "pointer" },
  },
  [`& .${paperCandidateChallengeActionsClasses.actionsContainer}`]: {
    gap: theme.spacing(2),
  },
  [`& .${paperCandidateChallengeActionsClasses.actionsGroupContainer}`]: {
    gap: theme.spacing(1),
  },
  [`& .${paperCandidateChallengeActionsClasses.actionsGroupLabel}`]: {
    textTransform: "capitalize",
  },
}));
